<template>
	<div class="user-overview">
		<div class="page__header">
			<h1 class="title">User Overview</h1>
		</div>
		<div class="page__content--overlap">
			<div class="users">
				<table class="users__table">
					<tr
						class="user"
						v-for="user in users"
						:key="user.id">
						<td>
							<router-link
								tag="p"
								class="user__name"
								:to="`/profile/${user.username}`">
								{{user.username}}
							</router-link>
						</td>
						<td>
							<p class="user__email">{{user.email}}</p>
						</td>
						<td>
							<p class="user__created">{{user.createdAt}}</p>
						</td>
						<td>
							<p class="user__role">{{user.role}}</p>
						</td>
						<td>
							<button v-if="user.role !== 'super'" class="user__delete" type="button" @click="deleteUser(user)">
								<i class="fas fa-trash-alt"></i>
								Delete User
							</button>
						</td>
					</tr>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
import ProfileService from '@/services/ProfileService'
export default {
	props: {
	},
	data () {
		return {
			users: []
		}
	},
	methods: {
		async getUsers () {
			this.users = await ProfileService.getUsers()
		},
		async deleteUser (user) {
			if (user.role === 'super') return
			if (confirm('Do you really wish to delete this user?')) {
				await ProfileService.deleteUser(user.username)
				this.getUsers()
			}
		}
	},
	computed: {
	},
	async created () {
		this.getUsers()
	}
}
</script>

<style lang="scss" scoped>
.users__table {
	@extend %table;
	@extend %table--brick;
}
.user__delete {
	@extend %button--tertiary;
}
</style>
